<script>
//    import Modal from '@/Scripts4.0/admin-toolbar-vue/components/vue-bootstrap-modal';
    import Modal from '@/Scripts4.0/checkout/delivery-address/components/vue-bootstrap-modal';
    import { useVuelidate } from '@vuelidate/core';
    import * as validators from '@vuelidate/validators';
    import { createI18nMessage, helpers } from '@vuelidate/validators';
    import FormInputText from './form-input-text';
    import DeliveryAddressApi from '../delivery-address-api';
    const messagePath = ({ $validator }) => `Vuelidate.${$validator.charAt(0).toUpperCase() + $validator.slice(1)}`;
    import i18n from '@/Scripts4.0/checkout/delivery-address/vue-deliveryaddress-i18n.js';
    const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n), messagePath });
    export const required = withI18nMessage(validators.required);
    export const email = withI18nMessage(validators.email);
    export const maxLength = withI18nMessage(validators.maxLength, { withArguments: true });

    export default {
        components: {
            'modal': Modal,
            'form-input-text': FormInputText
        },
        setup() {
            return { v$: useVuelidate() }
        },
        data: function () {
            return {
                showModal: false,
                name: '',
                address1: '',
                address2: '',
                address3: '',
                phonenumber: '',
                email: '',
                postcode: '',
                postid: 0,
                mobilephone: '',
                attention: '',
                countryid: 0,
                country: '',
                city: '',
                gln: '',
                showGln() {
                    return jQuery("body.customer-business").length > 0;
                },
                saveErrors: '',
                showSaveErrors() {
                    return this.saveErrors !== null && this.saveErrors.length > 0;
                }
            }
        },
        validations() {
            return {
                name: {
                    required: helpers.withParams({ attribute: this.$t('CUSTOMER_REGISTRATION.DeliveryName') }, required),
                    maxLength: helpers.withParams({ max: 50 }, maxLength(50)),                    
                },
                email: {
                    maxLength: helpers.withParams({ max: 80 }, maxLength(80)),
                    $lazy: true,
                    email
                },
                address1: {
                    required: helpers.withParams({ attribute: 'Address1' }, required),
                    maxLength: helpers.withParams({ max: 50 }, maxLength(50))
                },
                address2: {
                    maxLength: helpers.withParams({ max: 50 }, maxLength(50))
                },
                address3: {
                    maxLength: helpers.withParams({ max: 50 }, maxLength(50))
                },
                phonenumber: {
                    maxLength: helpers.withParams({ max: 50 }, maxLength(50))
                },
                postcode: {
                    required: helpers.withParams({ attribute: this.$t('CUSTOMER_REGISTRATION.Postnr') }, required),
                    maxLength: helpers.withParams({ max: 50 }, maxLength(50))
                },
                postid: {},
                mobilephone: {
                    required: helpers.withParams({ attribute: this.$t('CUSTOMER_REGISTRATION.DeliveryMobilePhoneNumber') }, required),
                    maxLength: helpers.withParams({ max: 50 }, maxLength(50))
                },
                attention: { },
                countryid: {},
                country: {},
                city: {
                    required: helpers.withParams({ attribute: this.$t('DeliveryAddress.UnkownPostCode') }, required),
                },
                gln: {
                    maxLength: helpers.withParams({ max: 15 }, maxLength(15))
                }

            };
        },
        mounted: function () {
            DeliveryAddressApi.getCountry()
                .then((response) => { 
                    this.countryid = response.data.LandID;
                    this.country = response.data.LandTxt;
                });

            this.open();
        },
        methods: {
            open: function () {
                // Reset forms
                this.showModal = true;
            },

            close: function () {
                this.showModal = false;
            },
            save: function () {
                let me = this; 
                this.v$.$validate().then(result => {
                    if (!result)
                        return;

                    const param = {
                        Name: this.name,
                        Address1: this.address1,
                        Address2: this.address2,
                        Address3: this.address3,
                        PhoneNumber: this.phonenumber,
                        Email: this.email,
                        PostId: this.postid,
                        City: this.city,
                        MobilePhone: this.mobilephone,
                        Attention: this.attention,
                        GLN: this.gln

                    };

                    DeliveryAddressApi.createDeliveryAddress(param)
                        .then((response) => {
                            var result = response.data;
                            if (!result.Success) {
                                me.saveErrors = result.Message;
                                this.$toast.error(this.$t('DeliveryAddress.CreateNewAddressError') + '\n' + result.Message + '\nError code:' + result.ErrorCode);
                                return;
                            }
                            this.$toast.success(this.$t('DeliveryAddress.CreateNewAddressSuccess'));
                            PubSub.publish("DeliveryAddress.NewAddressAdded", {id: result.GeneratedId});
                            this.close();

                        });

                });
            },
            updateCityFromPostCode: function () {
                DeliveryAddressApi.getCity(this.postcode, this.countryid)
                    .then((response) => {
                        if (response === null || response === undefined || response.status !== 200) {
                            return;
                        }
                        if (response.data === null) {
                            this.city = '';
                            this.postid = 0;
                            return;
                        }

                        this.city = response.data.Poststed;
                        this.postid = response.data.PostID;
                    });


            }
        },
        watch: {
            showModal: function (show) {
                var body = document.getElementsByTagName("BODY")[0];
                if (show) {
                    body.classList.add('overflow-hidden');
                } else {
                    body.classList.remove('overflow-hidden');
                }
            },
            
        }

    };

</script>
<template>
    <modal :showModal="showModal" @close="close()" class="new-delivery-address-modal">

        <template v-slot:header>
            <h4 class="modal-title">{{$t('DeliveryAddress.CreateNewAddressTitle')}}</h4>
        </template>

        <template v-slot:body>
            <div class="create-new-delivery-address-container">
                <fieldset id="otherDeliveryAddressContainer" class="delivery-address smart-label">
                    <div class="col-sm-12 business-reg-d-name">
                        <form-input-text v-model:value="name"
                                         :v="v$.name"
                                         input-id="levName"
                                         lazy-validation="false"
                                         :label="$t('CUSTOMER_REGISTRATION.DeliveryName')"
                                         class="inactive"
                                         icon="icon-star"
                                         name="name"
                                         placeholder="$t('CUSTOMER_REGISTRATION.DeliveryName')"
                                         input-class="form-control reg-textbox"
                                         autocomplete="shipping name" />
                    </div>

                    <div class="col-sm-12 business-reg-d-country">
                        <form-input-text v-model:value="country"
                                         :v="v$.country"
                                         input-id="delCountry"
                                         :label="$t('')"
                                         name="delCountry"
                                         class="inactive"
                                         :isDisabled="true"
                                         icon="fa fa-fw"
                                         inputClass="form-control reg-textbox"
                                         disabled="disabled" />
                    </div>

                    <div class="col-sm-12 business-reg-d-address1">
                        <form-input-text v-model:value="address1"
                                         input-id="levAddress1"
                                         :v="v$.address1"
                                         lazy-validation="false"
                                         :label="$t('CUSTOMER_REGISTRATION.Address')"
                                         icon="icon-star"
                                         class="inactive"
                                         name="city"
                                         placeholder="$t('CUSTOMER_REGISTRATION.Address')"
                                         input-class="form-control reg-textbox"
                                         autocomplete="shipping address-line1" />
                    </div>

                    <div class="col-sm-12 business-reg-d-address2">
                        <form-input-text v-model:value="address2"
                                         input-id="levAddress2"
                                         lazy-validation="false"
                                         :label="$t('CUSTOMER_REGISTRATION.AddressTilleg')"
                                         name="city"
                                         class="inactive"
                                         :v="v$.address2"
                                         placeholder="$t('CUSTOMER_REGISTRATION.AddressTilleg')"
                                         input-class="form-control reg-textbox"
                                         autocomplete="shipping address-line2" />
                    </div>

                    <div class="col-sm-12 business-reg-d-address3">
                        <form-input-text v-model:value="address3"
                                         input-id="levAddress3"
                                         lazy-validation="false"
                                         :label="$t('CUSTOMER_REGISTRATION.AddressTilleg')"
                                         name="address-line3"
                                         class="inactive"
                                         :v="v$.address3"
                                         placeholder="$t('CUSTOMER_REGISTRATION.AddressTilleg')"
                                         input-class="form-control reg-textbox"
                                         autocomplete="shipping address-line3" />
                    </div>

                    <div class="col-sm-4 business-reg-d-zipcode">
                        <form-input-text v-model:value="postcode"
                                         input-type="tel"
                                         @blur="updateCityFromPostCode"
                                         input-id="levZzipCode"
                                         :v="v$.postcode"
                                         :label="$t('CUSTOMER_REGISTRATION.Postnr')"
                                         name="state"
                                         icon="icon-start"
                                         class="inactive"
                                         placeholder="$t('CUSTOMER_REGISTRATION.Postnr')"
                                         input-class="form-control reg-textbox"
                                         autocomplete="shipping postal-code" />
                    </div>

                    <div class="col-sm-8 business-reg-d-city">
                        <form-input-text v-model:value="city"
                                         :v="v$.city"
                                         input-id="levCity"
                                         :label="$t('CUSTOMER_REGISTRATION.Poststed')"
                                         class="inactive"
                                         icon="icon-star"
                                         name="province"
                                         placeholder="$t('CUSTOMER_REGISTRATION.Poststed')"
                                         input-class="form-control reg-textbox inactive"
                                         :isDisabled="true"
                                         autocomplete="shipping address-level2" />
                    </div>

                    <div class="col-sm-6 business-reg-d-contact">
                        <form-input-text v-model:value="attention"
                                         :v="v$.attention"
                                         input-id="levContactName"
                                         :label="$t('CUSTOMER_REGISTRATION.WizzardContactPerson')"
                                         class="inactive"
                                         name="levContactName"
                                         placeholder="$t('CUSTOMER_REGISTRATION.WizzardContactPerson')"
                                         input-class="form-control reg-textbox"
                                          />
                    </div>

                    <div class="col-sm-6 business-reg-d-phone">
                        <form-input-text v-model:value="mobilephone"
                                         :v="v$.mobilephone"
                                         input-id="levPhone"
                                         :label="$t('CUSTOMER_REGISTRATION.DeliveryMobilePhoneNumber')"
                                         class="inactive"
                                         icon="icon-star"
                                         name="phone"
                                         placeholder="$t('CUSTOMER_REGISTRATION.DeliveryMobilePhoneNumber')"
                                         input-class="form-control reg-textbox"
                                         autocomplete="shipping tel" />
                    </div>

                    <div class="col-sm-6 business-reg-d-emails">
                        <form-input-text v-model:value="email"
                                         input-id="levEmail"
                                         :v="v$.email"
                                         :label="$t('LOGINOUT.ValidEmail')"
                                         name="email"
                                         class="inactive"
                                         placeholder="$t('LOGINOUT.ValidEmail')"
                                         input-class="form-control reg-textbox"
                                         autocomplete="shipping email" />
                    </div>
                    <div class="col-sm-6 business-reg-d-phone">
                        <form-input-text v-model:value="phonenumber"
                                         :v="v$.phonenumber"
                                         input-id="levPhone2"
                                         :label="$t('CUSTOMER_REGISTRATION.DeliveryPhone')"
                                         class="inactive"
                                         name="phone"
                                         placeholder="$t('CUSTOMER_REGISTRATION.DeliveryPhone')"
                                         input-class="form-control reg-textbox"
                                         autocomplete="shipping tel" />
                    </div>

                    <div class="col-sm-12 business-reg-d-gln" v-if="showGln()">
                        <form-input-text v-model:value="gln"
                                         input-id="levGln"
                                         :label="$t('DeliveryAddress.GLN')"
                                         name="gln"
                                         class="inactive"
                                         :v="v$.gln"
                                         maxlength="15"
                                         placeholder="$t('CUSTOMER_REGISTRATION.AddressTilleg')"
                                         input-class="form-control reg-textbox"
                                         autocomplete="shipping gln" />
                    </div>


                </fieldset>
                <div class="clearfix"></div>
            </div>

        </template>
        <template v-slot:footer>
            <div class="save-errors" v-if="saveErrors != ''">
                {{saveErrors}}
            </div>
            <button type="button" class="btn btn-default" @click="close()">{{$t('VueAdmin.Cancel')}}</button>
            <button type="button" class="btn btn-primary"  @click="save()">{{$t('DeliveryAddress.AddAddress')}}</button>
        </template>
    </modal>
</template>

<style lang="scss">
    .smart-label input.reg-textbox.inactive:disabled{
        background-color:#eee;
    }
    .save-errors {
        text-align: left;
        font-weight: bold;
        background-color: crimson;
        color: white;
        border-radius: 5px;
        border-radius: 5px;
        min-height: 30px;
        width: calc(100% - 20px);
        vertical-align: middle;
        padding-top: 5px;
        margin-left: 10px;
        margin-right: 30px;
        padding-right: 10px;
        padding-left: 10px;
    }
</style>